module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/arrows-88598b89ff61e0bbdf386a0404b90acf.svg";